import { rgba } from 'polished';

const selectStyles = ({
  props,
  theme,
  variantProps,
  styleProps,
  styles,
}) => {
  const { focus, hover, ...boxProps } = styleProps.input;
  const { focus: focusVariant, hover: hoverVariant, ...variantBoxProps } = variantProps.input;
  const { tag, ...typographyProps } = theme.typography.body;

  const {
    typography: customTypographyStyles,
    input: customInputStyles,
    control: customControlStyles,
    ...customStyles
  } = styles;

  const textStyles = (provided) => ({
    ...provided,
    fontFamily: theme.fonts.regular,
    ...typographyProps,
    ...variantBoxProps,
    ...customTypographyStyles,
  });

  return ({
    input: textStyles,
    singleValue: textStyles,
    loadingMessage: textStyles,
    noOptionsMessage: textStyles,

    multiValue: (provided) => ({
      ...textStyles(provided),
      borderRadius: '12px',
      backgroundColor: theme.colors.coldgrey300,
    }),

    multiValueLabel: (provided) => ({
      ...textStyles(provided),
      ...theme.typography.capsSM,
      color: theme.colors.coldgrey700,
    }),

    multiValueRemove: (provided) => ({
      ...textStyles(provided),
      borderRadius: '0 12px 12px 0',
      color: theme.colors.coldgrey700,
    }),

    placeholder: (provided) => ({
      ...textStyles(provided),
      color: theme.colours.coldgrey500,
    }),

    menu: (provided) => ({
      ...provided,
      border: 'none',
      boxShadow: theme.shadows.light[4] || '',
      zIndex: 100,
    }),

    valueContainer: (provided) => {
      let padding = '8px 12px';

      if (props.size === 'lg') {
        padding = '10px';
      }

      return {
        ...provided,
        padding,
        ...customInputStyles,
      };
    },

    option: (provided, state) => ({
      ...provided,
      ...textStyles(provided),
      cursor: state.isDisabled ? 'not-allowed' : provided.cursor,
      backgroundColor: 'transparent',
      color: theme.colors.coldgrey700,
      ...state.isSelected && {
        backgroundColor: theme.colors.coldgrey200,
      },

      '&:hover': {
        backgroundColor: state.isDisabled ? 'transparent' : rgba('black', 0.04),
        color: theme.colors.coldgrey700,
      },
    }),

    control: (provided, state) => ({
      ...provided,
      transition: theme.transitions.button,
      borderStyle: 'solid',
      borderRadius: 6,
      outline: 'none',
      userSelect: 'none',
      boxShadow: 'none',
      ...boxProps,
      ...variantBoxProps,
      ...state.isFocused && {
        ...(focusVariant || focus),
        outline: 'none',
      },

      '&:hover': {
        ...(hoverVariant || hover),
        outline: 'none',
      },

      ...customControlStyles,
    }),

    ...customStyles,
  });
};

export default selectStyles;
